export default __webpack_public_path__ + "static/media/watch-icon.a31054c2.svg";